import Vue from 'vue';

export var applicationSlide = Vue.component({
	template: '#application-slide-template',
	props:['label', 'img_url'],
});
